import React, {Component} from 'react'
import {Row, Col, Card, CardHeader, CardBody, Button} from 'reactstrap'
import {graphql, withApollo} from 'react-apollo'
import PropTypes from 'prop-types'
import {Line} from 'react-chartjs-2'
import {RiseLoader} from 'react-spinners'
import CreatableSelect from '../Wps/CreatableSelect'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import moment from 'moment'
import { ProjectsFetchQuery, ElementsFetchQuery, WeldingProgressHistoryFetchQuery } from './query'
// import {withGaEvent} from '../Support/GoogleAnalytics'

const options = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    xAxes: [{
      display: true,
      time: {
        unit: 'day'
      }
    }],
    yAxes: [{
      display: true,
      scaleLabel: {
        display: true,
        labelString: '%'
      },
      ticks: {
        beginAtZero: true,
        steps: 10,
        stepValue: 5,
        max: 100
      }
    }]
  }
}

class WorkProgress extends Component {

  constructor(props) {
    super(props)
    this.state = {
      project: null,
      element: null,
      date_from: '',
      date_to: new Date().toISOString().substring(0, 10),
      project_elements: [],
      invalid_submit: false,
      chart_data: {
        labels: [],
        datasets: [
          {
            label: 'Progress',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [],
          },
          {
            label: 'Last welding',
            data: [],
            backgroundColor: 'rgba(255,140,0,0.4)',
            borderColor: 'rgba(255,140,0,0.3)',
            pointRadius: 0,
            pointHitRadius: 0,
          },
          {
            label: 'Planned start',
            data: [],
            backgroundColor: 'rgba(0,135,44,0.9)',
            borderColor: 'rgba(0,135,44,0.9)',
            pointRadius: 0,
            pointHitRadius: 0,
          },
          {
            label: 'Planned end',
            data: [],
            backgroundColor: 'rgba(215,40,40,0.9)',
            borderColor: 'rgba(215,40,40,0.9)',
            pointRadius: 0,
            pointHitRadius: 0,
          },
        ],
      }
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleProjectSelectValueChange = this.handleProjectSelectValueChange.bind(this)
    this.handleElementSelectValueChange = this.handleElementSelectValueChange.bind(this)
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    client: PropTypes.object.isRequired
  }

  fetchChartData(project_id) {
    this.props.client.query({
      query: WeldingProgressHistoryFetchQuery,
      fetchPolicy: 'network-only',
      variables: {
        project_id: project_id,
        date_from: this.state.date_from,
        date_to: this.state.date_to
      }
    }).then(({data}) => {
      let newChartData = this.state.chart_data
      newChartData.labels = data.welding_progress_history.labels.slice(0) //clone
      newChartData.datasets[0].data = data.welding_progress_history.data.slice(0) //clone

      let attrs = ['welding_end_date', 'planned_start_date', 'planned_end_date']
      attrs.forEach((attr, idx) => {
        if (data.welding_progress_history.labels.includes(data.welding_progress_history[attr])) {
          newChartData.datasets[idx + 1].data = [
            {x: data.welding_progress_history[attr], y: 0},
            {x: data.welding_progress_history[attr], y: 100}
          ]
        } else {
          newChartData.datasets[idx + 1].data = []
        }
      })

      this.setState({chart_data: newChartData, invalid_submit: false})
    })
  }

  handleProjectSelectValueChange(val) {
    this.setState({
      project: val,
      element: null,
      project_elements: [],
      date_from: (val && this.dateBackOneDay(val.created_at)) || ''
    },
    () => {
      if (val) {
        this.fetchChartData(val.id)
      }
    })

    if (val) {
      this.props.client.query({
        query: ElementsFetchQuery,
        fetchPolicy: 'network-only',
        variables: {
          parent_id: Number(val.id),
        }
      }).then(({data}) => {
        this.setState({project_elements: data.elements.list})
      })
    }
  }

  handleElementSelectValueChange(val) {
    this.setState({element: val, date_from: (val && this.dateBackOneDay(val.created_at)) || ''}, () => {
      if (val) {
        this.fetchChartData(val.id)
      }
    })
  }

  handleSubmit() {
    let project_id = (this.state.element && this.state.element.id) || (this.state.project && this.state.project.id)

    if (project_id) {
      // withGaEvent({category: 'Work Progress', action: 'filter'}) // GA EVENT
      this.fetchChartData(project_id)
    } else {
      this.setState({invalid_submit: true})
    }
  }

  dateBackOneDay(date) {
    let momentDate = moment(date, 'DD-MM-YYYY')
    return momentDate.subtract(1, 'days').format('YYYY-MM-DD')
  }

  render() {
    if (this.props.data.loading) {
      return (
        <div className="spinner-item" id="loader-bg">
          <RiseLoader
            color="#20a8d8"
            loading={true}
          />
        </div>
      )
    }

    if (this.props.data.error) {
      if (this.props.data.error.networkError && this.props.data.error.networkError.statusCode === 404) {
        return (<div>Not Found</div>)
      } else {
        return (<div>An unexpected error occurred</div>)
      }
    }

    return (
      <div className="animated fadeIn">
        <Card>
          <CardHeader>
            <AvForm id="reports-work-progress-form" onValidSubmit={this.handleSubmit} className="FormClassLabel">
              <Row>
                <Col xs="12" sm="6">
                  <CreatableSelect label="Project" id="project-select"
                    options={this.props.data.projects.list}
                    valueKey="id"
                    value={this.state.project}
                    multi={false}
                    creatable={false}
                    valueChangeFunction={this.handleProjectSelectValueChange}
                  />
                  {this.state.invalid_submit && <div className="invalid-feedback">This field is invalid</div>}
                </Col>
                <Col xs="12" sm="6">
                  <CreatableSelect label="Element" id="element-select"
                    options={this.state.project_elements}
                    valueKey="id"
                    value={this.state.element}
                    multi={false}
                    creatable={false}
                    valueChangeFunction={this.handleElementSelectValueChange}
                  />
                </Col>
              </Row>
              <br/>
              <Row>
                <Col xs="12" sm="3">
                  <AvField id="reports-work-progress-date-from"
                    value={this.state.date_from}
                    onChange={e => this.setState({date_from: e.target.value})}
                    max={this.state.date_to}
                    name="date_from"
                    label="Date from"
                    type="date"
                    style={{height: '35px'}}
                    required/>
                </Col>
                <Col xs="12" sm="3">
                  <AvField id="reports-work-progress-date-to"
                    value={this.state.date_to}
                    onChange={e => this.setState({date_to: e.target.value})}
                    max={new Date().toISOString().substring(0, 10)}
                    min={this.state.date_from}
                    name="date_to"
                    label="Date to"
                    type="date"
                    style={{height: '35px'}}
                    required/>
                </Col>

                <Col xs="12" sm="3">
                  <Button id="reports-work-progress-show-btn" type="submit" color="primary" style={{marginTop: '30px'}}>
                    <i className="fa fa-filter"/> Filter
                  </Button>
                </Col>
              </Row>
            </AvForm>
          </CardHeader>
          <CardBody>
            <div className="chart-wrapper">
              <Line
                data={this.state.chart_data}
                options={options}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

const WorkProgressWithData = graphql(ProjectsFetchQuery, {
  options: () => {
    return {
      fetchPolicy: 'network-only',
    }
  },
}
)(WorkProgress)

export default withApollo(WorkProgressWithData)



// WEBPACK FOOTER //
// ./src/components/Report/WorkProgress.js